export default {
    'name': 'arrow',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M4.29057 7.83348C4.0953 7.63821 3.77872 7.63821 3.58346 7.83348C3.3882 8.02874 3.3882 8.34532 3.58346 8.54058L11.6464 16.6036C11.7402 16.6973 11.8674 16.75 12 16.75C12.1326 16.75 12.2598 16.6973 12.3535 16.6036L20.4165 8.54058C20.6117 8.34532 20.6117 8.02874 20.4165 7.83348C20.2212 7.63821 19.9046 7.63821 19.7094 7.83348L12 15.5429L4.29057 7.83348Z\' fill=\'#42A463\'/>'
}
